<template>
  <app-layout>
    <PageTitle :headerTitle="title"> </PageTitle>

    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
      <div class="bg-white overflow-hidden px-3 shadow-xl sm:rounded-lg">
        <div class="row pt-3 px-2">
            <div class="col">
                <a class="btn-back text-sm mt-4" href="#">Back</a>
                &nbsp;
                <jet-button @click="editItem"  class="btn-suspend cursor-pointer btn-suspend-container text-sm"  > Edit </jet-button> &nbsp;
                <jet-button class="btn-delete text-sm " @click="deleteItem">
                        Delete
                </jet-button>
                

            </div>
        </div>
        <form class="p-2 mt-2" @submit.prevent="submit">
          <BsShow
            :createDef="detailDef"
            :routeDef="moduleRoute"
            :modelData="modelData1"
          >
          </BsShow>
          <!-- <input class="mt-2 bg-blue-500 text-xs" type="submit" value="Submit" /> -->
        </form>
        <div class="pt-2">
          <DxTabPanel>
            <DxItem
              v-for="data in relationData.items"
              icon="fields"
              :title="data.title"
              :key="data.title"
            >
              <div class="px-2" >
                {{ data.text }}
                <test>
                </test>
           
              </div>
            </DxItem>
          </DxTabPanel>
        </div>
      </div>
    </div>
  </app-layout>
</template>
<script>
import AppLayout from '@include/pages/BaseLayouts/tallyClinicAppLayout.vue';
import BsShow from '@/Base/BsShow.vue';
import PageTitle from "@/Layouts/PageTitle.vue";
import Test from "@/components/TestCompo.vue";
import DxTabPanel, { DxItem } from "devextreme-vue/tab-panel";
import DxDataGrid from "devextreme-vue/data-grid";
import { employees, states, showAlert, logd } from "@/Utils/Utils.js";
import {
  DxColumn,
  DxFormItem,
  DxPaging,
  DxEditing,
  DxLookup,
} from "devextreme-vue/data-grid";
import "devextreme-vue/text-area";
import CustomStore from "devextreme/data/custom_store";

const modelData = {};
let mRoute;
let headerResponse;
function setRoute(context) {
  mRoute = context.routeDef;
}

const dataStore = new CustomStore({});

export default {
        props: {
            detailDef:{
                type: Array,
                default: []
            },
            moduleRoute:String,
            modelData:{
                type: Object,
                default: () => ({})
            },
            relationData :{
                type: Array,
                default: []
            },
            route:""
        },
        components: {
        AppLayout,
        BsShow,
        PageTitle,
        DxTabPanel,
        DxItem,
        Test,
        DxDataGrid,
    
    },
    data: function() {

        return {
            title:_.startCase(this.moduleRoute),
            modelData1:this.modelData,

            form: this.$inertia.form(),
        }
    },
     mounted() {
         //console.log(_.startCase(this.moduleRoute));
        // console.log(this.modelData);
                },
    methods: {
        deleteItem() {
            
            this.form.delete(route('tenants.destroy', this.modelData.id), {
                errorBag: 'deleteIteam'
            });
        },
        editItem() {
           
            this.form.get(route(this.route+'.edit', this.modelData.results.id), {
                errorBag: 'UpdateItem'
            });
        },
        hello(){
            alert('hello');
        }
       
    },
    
}


</script>

   <style>
/* This is added because the settings icon was moving up - START */

.manage-margin-in-detail {
  margin-top: 4px;
}

/* This is added because the settings icon was moving up - START */

/*Panel tabs*/
#tab-contents {
  margin: 0 auto;
}

.detail,
.details-tabs-container {
  background-color: var(--white);
  border: 1px solid #ebebeb;
}

.setting-icon-margin-manage {
  margin-top: 0.6px;
}

a {
  text-decoration: none !important;
}

a:hover {
  color: #000;
}
.nav-panel-heading {
  margin-top: 10px;
}

.detail-heading {
  border-bottom: 1px solid var(--input_grey);
  padding: 2px;
}

.tabs {
  padding: 0;
  display: flex;
  border-bottom: 1px solid var(--input_grey);
  color: var(--text_grey);
}

.detail-tabs {
  margin: 0px 0px 0px 0px !important;
}

.tabs li {
  position: relative;
  background-color: var(--white);
  cursor: pointer;
  font-weight: normal;
  margin: 0px 0px 0px 0px !important;
  padding: 5px 20px !important;
  border-radius: 0px !important;
  list-style-type: none;
}

.tabs li.active {
  border-bottom: 2px solid var(--blue);
  color: #333;
  font-weight: bold;
}

.tabs li::before {
  content: "";
  visibility: hidden;
  width: 0;
  height: 2px;
  border-bottom: 1px solid var(--blue);
  background-color: var(--blue);
}

.tabs li:hover {
  background-color: #c6e3ff;
  color: var(--blue);
  font-weight: bold;
}

.tabs li:hover::before {
  visibility: visible;
  bottom: 0;
  width: 100%;
}

.panel {
  display: none;
  background: var(--white);
  box-shadow: 0 0 0 0 transparent;
  padding: 0 15px;
}

.panel.active {
  display: block;
}

.heading-row-margins {
  margin-left: 13px;
}

.breadcrumb-margin {
  margin-right: -8px;
}

.btn-back {
  background-color: var(--blue) !important;
  color: var(--white);
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 2px;
  padding-bottom: 2px;
}

a {
  text-decoration: none !important;
}

a:hover {
  color: #000;
}

.btn-suspend {
  background-color: var(--orange) !important;
  color: var(--white);
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 2px;
  padding-bottom: 2px;
}

btn-suspend:hover {
  color: #fff;
  background-color: #5a6268 !important;
}

.btn-up {
  background-color: var(--blue) !important;
  color: var(--white);
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 2px;
  margin-right: 5px;
  padding-bottom: 2px;
}

btn-up:hover {
  color: #000;
}

.btn-delete {
  background-color: var(--red) !important;
  color: var(--white);
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 2px;
  margin-right: 5px;
  padding-bottom: 2px;
}

.btn-delete:hover {
  color: #000;
}

.btn-delete-container {
  position: absolute;
  right: 10px;
  margin-top: -25px;
}

.btn-suspend-container {
  position: absolute;
  right: 120px;
}
</style>